import styled from "styled-components";
import {Box, Grid} from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    padding-bottom: 16px;
  }
`;

